<template>
	<div>
		<section class="transfer-contact-container">
			<FallBack
				v-if="error"
				:message="error"
				transparentBackground
				iconStyle="fal"
				icon="exclamation-triangle"
			/>
			<div v-else>
				<p class="transfer-modal-text">
					Transferring a contact will also transfer any loans this
					contact is the primary borrower on. Are you sure you want to
					transfer
					{{ thisOrThese }} contact?
				</p>
				<FormDropdowns
					name="transfer-contact"
					class="transfer-contacts-dropdown"
					v-model="contactId"
					:label="label"
					:options="brokerContactsList"
				/>
				<div class="error-container">
					<div class="error-spacer"></div>
					<div v-if="showError" class="show-error">
						<span class="error-text" data-test="error-text"
							>Select a broker</span
						>
					</div>
				</div>
			</div>
		</section>
		<OverviewModalFooter
			:success="success"
			:waiting="waiting"
			:isSaveModal="true"
			@handleClick="handleTransferContactAction"
			@close="$emit('handleClose')"
		/>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FallBack from '@/components/global/FallBack.vue';
import FormDropdowns from '../../../components/global/FormDropdowns.vue';
import OverviewModalFooter from './OverviewModalFooter.vue';

export default {
	name: 'TransferContact',
	components: {
		FallBack,
		FormDropdowns,
		OverviewModalFooter,
	},
	props: {
		brokerContactsList: Array,
		companyIds: Array,
		leadId: Number,
		selectAllMode: Boolean,
		selectedLeadIds: Array,
	},
	data() {
		return {
			contactId: null,
			waiting: false,
			showError: false,
			success: false,
			error: null,
		};
	},
	computed: {
		...mapState({
			filters: (state) => state.ccContacts.filters,
			selectedBrokers: (state) =>
				state.clientConnectV2.selectedContactsIds,
			totalCount: (state) => state.ccContacts.leads.totalCount,
		}),
		brokerName() {
			if (this.contactId) {
				const selectedBroker = this.brokerContactsList.find(
					(broker) => broker.value === this.contactId,
				);
				return selectedBroker.name;
			}
			return '';
		},
		contactsToTransfer() {
			if(this.leadId) return [this.leadId];
			return this.selectedLeadIds;
		},
		currentFilters() {
			const [entityId, brokerIds] = this.companyIds;
			let filters = {
				data: {
					...this.filters,
					entityId,
				},
			};
			filters.searchTerm = filters.data.searchTerm;
			delete filters.data.searchTerm;

			if (this.selectedBrokers.length === 0) {
				filters.data.contactsIds = brokerIds;
			} else {
				filters.data.contactsIds = this.selectedBrokers;
			}
			return filters;
		},
		selectAll() {
			if(this.leadId) return false;
			return this.selectAllMode
		},
		selectedContacts() {
			if (this.selectAllMode) {
				return this.totalCount - this.selectedLeadIds.length;
			}
			return this.selectedLeadIds.length;
		},
		label() {
			if (this.selectedContacts === 1 || this.leadId) {
				return 'Transfer Contact to';
			}
			return `Transfer ${this.selectedContacts} Contacts to`;
		},
		thisOrThese() {
			return this.selectedLeadIds.length < 2 || this.leadId
				? 'this'
				: 'these';
		},
	},
	methods: {
		...mapActions(['transferLeads', 'editContactProperty']),
		async handleTransferContactAction() {
			if (this.contactId === null) {
				this.showError = true;
				return;
			}
			let payload = {};

			if (!this.selectAll) {
				payload = {
					contactId: this.contactId,
					leadIds: this.contactsToTransfer,
					selectAllMode: this.selectAll,
				};
			} else {
				payload = {
					contactId: this.contactId,
					leadIds: this.contactsToTransfer,
					selectAllMode: this.selectAll,
					filters: this.currentFilters,
				};
			}

			this.waiting = true;
			try {
				await this.transferLeads(payload);
				this.success = true;
				setTimeout(() => {
					if (this.selectedLeadIds && this.leadId) {
						this.$emit('filterLeadId');
					} else {
						this.$emit('clearLeadIds');
					}
					this.editContactProperty({
						prop: 'owner',
						value: this.brokerName,
						leadIds: this.contactsToTransfer,
						selectAll: this.selectAll,
					});
					this.success = false;
				}, 1500);
			} catch (error) {
				this.error = error.message;
			}
			this.waiting = false;
		},
	},
	watch: {
		contactId(newValue) {
			if (newValue !== null) {
				this.showError = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.transfer-contact-container {
	@include rem('padding', 20px);
}

p.transfer-modal-text {
	padding: 0;
	@include rem('margin', 0 0 15px);
	line-height: 1.5;
}

.transfer-contacts-dropdown {
	display: flex;
	align-items: center;
	column-gap: 10px;
	flex-wrap: wrap;
	justify-content: space-between;
	white-space: nowrap;

	& /deep/ .b360-form-input--select {
		width: clamp(200px, 40vw, 275px);
	}
}

.error-container {
	display: flex;
	align-items: center;
	column-gap: 10px;
	flex-wrap: wrap;
	justify-content: space-between;
	white-space: nowrap;

	.error-spacer {
		width: 171.44px;
	}

	.show-error {
		width: clamp(200px, 40vw, 270px);

		.error-text {
			color: $error;
			padding: 0;
			width: clamp(200px, 40vw, 270px);
			line-height: 36px;
		}
	}
}
</style>
